const T = {
	alert: function(type, text, dark, block){
		let alertText = mkE({
			tag: 'div',
			className: 'alert-text'
		});
		mkE.appendTypeElement(alertText, text);
		return mkE({
			tag: 'div',
			className: 'alert alert-' + type + (dark === true ? ' alert-dark' : '') + (block === true ? ' alert-block' : ''),
			els: [
				{
					tag: 'div',
					className: 'alert-icon'
				},
				alertText
			]
		});
	},

	error: function(text, dark, block){
		return T.alert('error', text, dark === true, block === true);
	},

	success: function(text, dark, block){
		return T.alert('success', text, dark === true, block === true);
	},

	fatal: function(text, dark, block){
		return T.alert('fatal', text, dark === true, block === true);
	}
};
